import React from 'react';
import WidgetPaper from '@components/widgets/display-widget/WidgetPaper';
import WidgetSection from '@components/widgets/display-widget/WidgetSection';
import SelectFormField from '@components/form-fields/SelectFormField';
import NumberInputFormField from '@components/form-fields/NumberInputFormField';
import MultiselectFormField from '@components/form-fields/MultiselectFormField';

interface IProposalTravelDetailsPageProps {
  pageState: any;
  onPageStateUpdate: (pageState: any) => void;
  disabledForm?: boolean;
  lovs: Record<string, Record<string, string>>;
}

const ProposalTravelDetailsWidget: React.FC<
  IProposalTravelDetailsPageProps
> = ({ pageState, onPageStateUpdate, disabledForm, lovs }) => {
  const values = pageState.values.travelDetails;
  const errors = pageState.errors.travelDetails;
  const touched = pageState.touched.travelDetails;

  const onFieldBlur = (fieldName: string) => {
    const newPageState = { ...pageState };
    newPageState.touched.travelDetails[fieldName] = true;
    onPageStateUpdate(newPageState);
  };

  const onFieldUpdate = (fieldName: string, value: any) => {
    const newPageState = { ...pageState };
    newPageState.values.travelDetails[fieldName] = value;
    onPageStateUpdate(newPageState);
  };

  return (
    <WidgetPaper>
      <WidgetSection title="Travel Details" isFieldsGrid>
        <SelectFormField
          key="destination"
          name="destination"
          title="Destination*"
          placeholder="Destination"
          value={values.destination}
          error={touched.destination ? errors.destination : ''}
          onChange={(v) => onFieldUpdate('destination', v)}
          disabled={disabledForm}
          selectOptions={lovs.destinations}
          material
        />

        <NumberInputFormField
          key="duration"
          name="duration"
          title="Duration (in Days)*"
          placeholder="Duration"
          value={values.duration}
          error={touched.duration ? errors.duration : ''}
          onBlur={() => onFieldBlur('duration')}
          onChange={(e) => onFieldUpdate('duration', e.target.value)}
          disabled={disabledForm}
          material
        />

        <MultiselectFormField
          key="policyCover"
          name="policyCover"
          title="Policy Cover*"
          placeholder="Policy Cover"
          values={values.policyCover}
          error={touched.policyCover ? errors.policyCover : ''}
          onChange={(v) => onFieldUpdate('policyCover', v)}
          disabled={disabledForm}
          selectOptions={lovs.policyCovers}
          material
          fullWidth
        />
      </WidgetSection>
    </WidgetPaper>
  );
};

export default ProposalTravelDetailsWidget;
